<template>
  <div>
    <loading
      :active.sync="loading_state.is_loading"
      :is-full-page="true"
      :can-cancel="true"
      :height="100"
      loader="spinner"
      color="#0095e9"
    ></loading>

    <div>
      <navbar />
    </div>

    <b-container fluid>
      <div>
        <router-view></router-view>
      </div>
    </b-container>
  </div>
</template>

<script>
import NavbarCashier from '@/components/NavbarCashier';
import { mapState } from 'vuex';

export default {
  name: 'index-cashier',
  components: {
    navbar: NavbarCashier
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('StoreLoading', ['loading_state'])
  }
};
</script>

<style lang="scss"></style>
